import { createBrowserRouter, Navigate } from 'react-router-dom'
import RootLayout from '../layouts/RootLayout'
import LoginPage from '../pages/LoginPage'
import AuthCallbackPage from '../pages/AuthCallbackPage'
import MaintenancePage from '../pages/MaintenancePage'
import PrivacyConsentPage from '../pages/PrivacyConsentPage'
import CADDesignerPage from '../pages/CADDesignerPage'
import ChatPage from '../pages/ChatPage/ChatPage'
import ImageGeneratorPage from '../pages/ImageGeneratorPage'
import VideoGeneratorPage from '../pages/VideoGeneratorPage'
import PresentationGeneratorPage from '../pages/PresentationGeneratorPage'
import MemoryManagementPage from '../pages/MemoryManagementPage'
import ChatAssetsPage from '../pages/ChatAssetsPage'
import ImageGenTestPage from '../pages/ImageGenTestPage'
import AdminDashboardPage from '../pages/AdminDashboardPage'
import AdminKnowledgePage from '../pages/AdminKnowledgePage'
import AdminPrivacyPage from '../pages/AdminPrivacyPage'
import AdminFeedbackPage from '../pages/AdminFeedbackPage'
import FeatureFlagManager from '../pages/FeatureFlagManager'
import ErrorBoundaryWrapper from '../components/ErrorBoundaryWrapper'
import ProtectedRoute from './ProtecteRoutes'

const routes = [
  {
    element: <ErrorBoundaryWrapper />,
    children: [
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/auth/callback',
        element: <AuthCallbackPage />,
      },
      {
        element: <ProtectedRoute />,
        children: [
          // 1. Routes WITHOUT Sidebar (Standalone)
          {
            path: '/privacy-consent',
            element: <PrivacyConsentPage />,
          },
          {
            path: '/maintenance',
            element: <MaintenancePage />,
          },
          // Generators (Full Screen)
          {
            path: '/generate/image',
            element: <ImageGeneratorPage />,
          },
          {
            path: '/generate/video',
            element: <VideoGeneratorPage />,
          },
          {
            path: '/generate/presentation',
            element: <PresentationGeneratorPage />,
          },
          {
            path: '/generate/cad',
            element: <CADDesignerPage />,
          },
          // Admin (Full Screen)
          {
            path: '/admin/dashboard',
            element: <AdminDashboardPage />,
          },
          {
            path: '/admin/kb',
            element: <AdminKnowledgePage />,
          },
          {
            path: '/admin/privacy',
            element: <AdminPrivacyPage />,
          },
          {
            path: '/admin/feedback',
            element: <AdminFeedbackPage />,
          },
          {
            path: '/admin/features',
            element: <FeatureFlagManager />,
          },
          {
            path: '/test/imagegen',
            element: <ImageGenTestPage />,
          },
          {
            path: '/memories',
            element: <MemoryManagementPage />,
          },
          // 2. Routes WITH Sidebar
          {
            element: <RootLayout />,
            children: [
              {
                path: '/',
                element: <Navigate to="/chat" replace />,
              },
              {
                path: '/chat/assets',
                element: <ChatAssetsPage />,
              },
              {
                path: '/chat',
                element: <ChatPage />,
              },
              {
                path: '/chat/:conversationId',
                element: <ChatPage />,
              },
            ],
          },
        ],
      },
      // Catch-all
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
]

const router = createBrowserRouter(routes, {
  future: { v7_startTransition: true },
})

export default router
